module.exports = __webpack_public_path__ + "bin/76427a5fd16f41ea151b8957960662a6.png";